import styled from 'styled-components';
import colors from '../../../theme/Colors';
import theme from 'styled-theming';

const borderColor = theme('brand', {
    brenntag: colors.brenntag.secondary, 
    bcd: colors.bcd.primary
});

export const STable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
`;

export const STableHeader = styled.thead`
    color: #000066;
    border-bottom: 1px solid ${borderColor};
    th {
        font-size: 13px;
        padding: 12px;
        font-weight: normal;
        text-align: left;
        svg {
            margin-top: auto;
            margin-bottom: auto;
            margin-left: 6px;
        }
        &:nth-child(-n+2) {
            cursor: pointer;
        } 

    }
`;

export const STableRow = styled.tr`
    border-bottom: 1px solid #dddddd;
    &:last-child {
        border-bottom: 0;
    }
    
    ${props => props.onClick && `
        &:hover {
            cursor: pointer;
            background-color: #f2f2f2;
        }
    `};
`;

export const STableColumn = styled.td`
    padding: 10px;
    font-size: 13px;
    svg {
        cursor: pointer;
    }
    &.country {
        text-transform: capitalize;
    }
`;

